import React from "react";
import {
    Box,
    IconButton,
} from "@mui/material";

// Components 
import { TextField } from "@/theme/inputs/textfields";
import { HtmlField } from "@/theme/inputs/htmlfields";
import Icon from "@/theme/vectors/bundle";

const ProductInfoTab = ({ 
    product, 
    onChange, 
    saving, 
    initiallyHadSlug, 
    onGenerateSlug, 
    t 
}) => {
    return (
        <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
                label={t('product.detail.productName')}
                name="headline"
                fullWidth
                value={product.headline}
                onChange={onChange}
                disabled={saving}
                required
                InputLabelProps={{ shrink: true }}
            />
            
            <TextField
                label={t('product.detail.slug')}
                name="slug"
                fullWidth
                value={product.slug || ""}
                onChange={onChange}
                disabled={saving}
                placeholder={t('product.detail.slugPlaceholder')}
                helperText={t('product.detail.slugHelperText')}
                InputLabelProps={{ shrink: true }}
                InputProps={initiallyHadSlug ? {
                    endAdornment: (
                        <IconButton 
                            onClick={onGenerateSlug}
                            size="small"
                            title={t('product.detail.generateSlug')}
                        >
                            <Icon name="refresh2" />
                        </IconButton>
                    )
                } : undefined}
            />
            
            <HtmlField
                label={t('product.detail.intro')}
                name="intro"
                value={product.intro || ""}
                onChange={onChange}
                disabled={saving}
                placeholder={t('product.detail.introPlaceholder')}
                helperText={t('product.detail.introHelperText')}
                minHeight={150}
                floatingLabel={true}
            />
            
            <HtmlField
                label={t('product.detail.content')}
                name="content"
                value={product.content || ""}
                onChange={onChange}
                disabled={saving}
                placeholder={t('product.detail.contentPlaceholder')}
                helperText={t('product.detail.contentHelperText')}
                minHeight={250}
                floatingLabel={true}
            />
        </Box>
    );
};

export default ProductInfoTab;